/* eslint prettier/prettier: 0 */

import { MyFormControlHelpers, MyLayoutHelpers } from "@macashipo/mlib"
import React from "react"

//alert
const MFCAlert = React.lazy(() => import("./Types/alert"))

//
const MFCTextarea = React.lazy(() => import("./Types/textarea"))
const MFCSelect2 = React.lazy(() => import("./Types/select2"))

const MFCNumberDecimal = React.lazy(() => import("./Types/number_decimal"))
const MFCNumberNatural = React.lazy(() => import("./Types/number_natural"))
const MFCNumber = React.lazy(() => import("./Types/number"))
const MFCCurrency = React.lazy(() => import("./Types/currency"))
const MFC_currency_auto_vnd = React.lazy(() => import("./Types/currency_auto_vnd"))
const MFCPassword = React.lazy(() => import("./Types/password"))
const MFC_checkbox = React.lazy(() => import("./Types/checkbox"))
const MFC_readonly = React.lazy(() => import("./Types/readonly"))
const MFC_layout_row = React.lazy(() => import("./Types/layout_row"))
const MFC_layout_grid = React.lazy(() => import("./Types/layout_grid"))
const MFC_layout_group = React.lazy(() => import("./Types/layout_group"))
const MFC_arrtext = React.lazy(() => import("./Types/arrtext"))
const MFC_select_tag = React.lazy(() => import("./Types/select_tag"))
const MFC_select_table_api = React.lazy(() => import("./Types/select_table_api"))
const MFC_custom = React.lazy(() => import("./Types/custom"))
const MFC_checkbox_yesno = React.lazy(() => import("./Types/checkbox_yesno"))
const MFC_checkbox_inbox = React.lazy(() => import("./Types/checkbox_inbox"))
const MFC_checkbox_styled = React.lazy(() => import("./Types/checkbox_styled"))
const MFC_percent = React.lazy(() => import("./Types/percent"))
const MFC_range = React.lazy(() => import("./Types/range"))
const MFC_files = React.lazy(() => import("./Types/files"))
const MFC_files_cloudflare = React.lazy(() => import("./Types/files_cloudflare"))
const MFC_textareafull = React.lazy(() => import("./Types/textareafull"))
const MFC_readonly_html = React.lazy(() => import("./Types/readonly_html"))
const MFC_html_editor = React.lazy(() => import("./Types/html_editor"))
const MFC_selectlist = React.lazy(() => import("./Types/selectlist"))
const MFC_selectlist_check = React.lazy(() => import("./Types/selectlist_check"))
const MFC_suggest_address = React.lazy(() => import("./Types/suggest_address"))
const MFC_table = React.lazy(() => import("./Types/table"))
const MFC_group_checkbox = React.lazy(() => import("./Types/group_checkbox"))
const MFC_multi_input = React.lazy(() => import("./Types/multi_input"))
const MFC_signature = React.lazy(() => import("./Types/signature"))
const MFC_select2_api = React.lazy(() => import("./Types/select2_api"))
const MFC_selectlist_check_api = React.lazy(() => import("./Types/selectlist_check_api"))
const MFC_file_one = React.lazy(() => import("./Types/file_one"))
const MFC_files_array = React.lazy(() => import("./Types/files_array"))
const MFC_with_myui = React.lazy(() => import("./Types/with_myui"))
const MFC_suggest_data = React.lazy(() => import("./Types/suggest_data"))
const MFC_chromecolor = React.lazy(() => import("./Types/chromecolor"))
const MFC_cccd = React.lazy(() => import("./Types/cccd"))
const MFC_rate = React.lazy(() => import("./Types/rate"))
const MFC_rate_half = React.lazy(() => import("./Types/rate_half"))

//text
const MFCText = React.lazy(() => import("./Types/text"))
const MFC_text_pattern = React.lazy(() => import("./Types/text_pattern"))
const MFC_text_mask = React.lazy(() => import("./Types/text_mask"))

//date
const MFCDatePicker = React.lazy(() => import("./Types/datepicker"))
const MFC_datepickermulti = React.lazy(() => import("./Types/datepickermulti"))
const MFC_timepicker = React.lazy(() => import("./Types/timepicker"))
const MFC_timepicker_text = React.lazy(() => import("./Types/timepicker_text"))
const MFC_datepicker_text = React.lazy(() => import("./Types/datepicker_text"))
const MFC_datetimepicker = React.lazy(() => import("./Types/datetimepicker"))
const MFC_datefromto = React.lazy(() => import("./Types/datefromto"))
const MFC_datefromto_flatpickr = React.lazy(() => import("./Types/datefromto_flatpickr"))
const MFC_select_month_year = React.lazy(() => import("./Types/select_month_year"))

//object
const MFC_obj_editor = React.lazy(() => import("./Types/obj_editor"))

const List = {
  //date
  date: MFCDatePicker,
  datepicker: MFCDatePicker,
  datepickermulti: MFC_datepickermulti,
  timepicker: MFC_timepicker,
  timepicker_text: MFC_timepicker_text,
  datepicker_text: MFC_datepicker_text,
  datetime: MFC_datetimepicker,
  datetimepicker: MFC_datetimepicker,
  dev_datefromto: MFC_datefromto, //đang dev chưa xong, cứ click vào là auto submit form
  datefromto_flatpickr: MFC_datefromto_flatpickr,
  select_month_year: MFC_select_month_year,
  //obj
  obj_editor: MFC_obj_editor,
  //text
  text: MFCText,
  text_pattern: MFC_text_pattern,
  text_mask: MFC_text_mask,
  //alert
  alert: MFCAlert,
  //
  rate_half: MFC_rate_half,
  rate: MFC_rate,
  cccd: MFC_cccd,
  currency_auto_vnd: MFC_currency_auto_vnd,
  chromecolor: MFC_chromecolor,
  suggest_data: MFC_suggest_data,
  with_myui: MFC_with_myui,
  files_array: MFC_files_array,
  file_one: MFC_file_one,
  selectlist_check_api: MFC_selectlist_check_api,
  select2_api: MFC_select2_api,
  signature: MFC_signature,
  multi_input: MFC_multi_input,
  group_checkbox: MFC_group_checkbox,
  table: MFC_table,
  suggest_address: MFC_suggest_address,
  selectlist_check: MFC_selectlist_check,
  selectlist: MFC_selectlist,
  html_editor: MFC_html_editor,
  readonly_html: MFC_readonly_html,
  textareafull: MFC_textareafull,
  currency: MFCCurrency,
  number: MFCNumber,
  number_decimal: MFCNumberDecimal,
  number_natural: MFCNumberNatural,
  select2: MFCSelect2,
  textarea: MFCTextarea,
  password: MFCPassword,
  checkbox: MFC_checkbox,
  readonly: MFC_readonly,
  layout_row: MFC_layout_row,
  layout_grid: MFC_layout_grid,
  layout_group: MFC_layout_group,
  arrtext: MFC_arrtext,
  select_tag: MFC_select_tag,
  select_table_api: MFC_select_table_api,
  custom: MFC_custom,
  checkbox_yesno: MFC_checkbox_yesno,
  checkbox_inbox: MFC_checkbox_inbox,
  checkbox_styled: MFC_checkbox_styled,
  percent: MFC_percent,
  range: MFC_range,
  files: MFC_files,
  // files: MFC_files_cloudflare, //test
  files_cloudflare: MFC_files_cloudflare,
}

const MFCW_ngang = React.lazy(() => import("./WrapControlTypes/ngang"))
const ListWrapLayout = {
  form_ngang: MFCW_ngang,
  form_horizontal: MFCW_ngang,
  form_row: MFCW_ngang,
}
const MyLayoutOne = {
  init() {
    MyFormControlHelpers.addTypesFromListLazy(List)
    MyLayoutHelpers.addTypesFromListLazy(ListWrapLayout)
  },
}

export default MyLayoutOne
